import { useEffect, useMemo, useRef } from 'react';
import { clsx } from 'clsx';
import {
  MAX_YEAR,
  MIN_YEAR,
} from '@/components/form/_primitives/date/dateInputUtils.ts';

type CalendarYearPickerProps = {
  currentYear: number;
  onPick: (year: number) => void;
  /** `touch` — kafle pod kciuk i wyższa lista, dla arkusza na telefonie. */
  size?: 'default' | 'touch';
};

const CalendarYearPicker = ({
  currentYear,
  onPick,
  size = 'default',
}: CalendarYearPickerProps) => {
  const years = useMemo(
    () =>
      Array.from({ length: MAX_YEAR - MIN_YEAR + 1 }, (_, i) => MIN_YEAR + i),
    [],
  );
  const containerRef = useRef<HTMLDivElement>(null);

  // Przewijamy tylko listę lat, nie przodków: `scrollIntoView` ciągnąłby też
  // stronę pod arkuszem albo popoverem.
  useEffect(() => {
    const container = containerRef.current;
    const btn = container?.querySelector<HTMLButtonElement>(
      `[data-year="${currentYear}"]`,
    );
    if (!container || !btn) return;
    container.scrollTop =
      btn.offsetTop - container.clientHeight / 2 + btn.clientHeight / 2;
  }, [currentYear]);

  return (
    <div
      ref={containerRef}
      className={clsx(
        'relative grid gap-1 overflow-y-auto',
        size === 'touch'
          ? 'max-h-[50dvh] grid-cols-4'
          : 'max-h-[240px] grid-cols-3',
      )}
    >
      {years.map((year) => (
        <button
          key={year}
          data-year={year}
          type="button"
          onClick={() => onPick(year)}
          className={clsx(
            'rounded-sm text-base-text hover:bg-neutral-100',
            size === 'touch' ? 'px-2 py-3 text-base' : 'px-2 py-1.5 text-sm',
            { 'bg-accent-200 hover:bg-accent-200': year === currentYear },
          )}
        >
          {year}
        </button>
      ))}
    </div>
  );
};

export default CalendarYearPicker;
